import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export class ContractorsAddRequest extends GenericRequest {

    // ContractorSave {
    //     id: number
    //     company_id: number
    //     name: string
    //     nif: string
    //     contact_person: string
    //     phone: string
    //     email: string
    //     address: string
    //     ccc: string
    //     disabled: boolean
    //     document_schema_id: number
    //     document_schema_monthly_id: number
    //     user_email: string
    //     user_plain_password: string
    //     user_password: string
    //     domain: string
    //     api_base_url: string
    //     api_username: string
    //     api_password: string
    //     show_create_task_window: boolean
    //     disabled: boolean
    //     script_worker_states: string
    // }

    contractorSave;

    constructor(contractorSave, reuseCompanyIfExists = false) {
        super(METHOD_PUT, ApiEndpoints.CONTRACTORS_ADD);
        this.contractorSave = {
            ...contractorSave,
            reuse_company_if_exists: reuseCompanyIfExists
        }
    }

    overrideRequest() {
        return this.contractorSave;
    }

}



// WEBPACK FOOTER //
// ./src/app/contractors/ws/ContractorsAddRequest.js